export class CompositeDataFileVisitor {
    constructor(...visitors) {
        this.visitors = visitors;
    }
    visitUnknown(doc) {
        this.visitors.forEach(visitor => visitor.visitUnknown(doc));
    }
    visitCompatibilityTable(doc) {
        this.visitors.forEach(visitor => visitor.visitCompatibilityTable(doc));
    }
    visitExternalFiled(doc) {
        this.visitors.forEach(visitor => visitor.visitExternalFiled(doc));
    }
    visitJsFilter(doc) {
        this.visitors.forEach(visitor => visitor.visitJsFilter(doc));
    }
    visitOclConstraint(doc) {
        this.visitors.forEach(visitor => visitor.visitOclConstraint(doc));
    }
    visitOclFilter(doc) {
        this.visitors.forEach(visitor => visitor.visitOclFilter(doc));
    }
    visitOption(doc) {
        this.visitors.forEach(visitor => visitor.visitOption(doc));
    }
    visitOptionGroup(doc) {
        this.visitors.forEach(visitor => visitor.visitOptionGroup(doc));
    }
    visitProduct(doc) {
        this.visitors.forEach(visitor => visitor.visitProduct(doc));
    }
    visitProductGroup(doc) {
        this.visitors.forEach(visitor => visitor.visitProductGroup(doc));
    }
}
//# sourceMappingURL=CompositeDataFileVisitor.js.map